import { render, staticRenderFns } from "./Kpis.vue?vue&type=template&id=11face38&"
import script from "./Kpis.vue?vue&type=script&lang=js&"
export * from "./Kpis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports